export default "__VITE_ASSET__6eda41d5__"